<template>
    <date-range-picker :ref="'rangeDatePicker_'+componentId" :initRange="selectedDate" @selected="onSelectedDate" i18n="EN"> </date-range-picker>
</template>
<script>
import moment from 'moment'
import DateRangePicker from 'vue-rangedate-picker'    

export default {
    props: ['value'],
    components: { 
        'date-range-picker' : DateRangePicker 
    },
    data() {
        return {
            componentId: null,
            selectedDate: this.value
        }
    },
    created: function(){
        this.componentId = this._uid
    },
    mounted: function(){
        this.$refs['rangeDatePicker_'+this.componentId].dateRange = {
            start: new moment(this.selectedDate.start).add(1,"days").toDate(),
			end: new moment(this.selectedDate.end).add(1,"days").toDate()
	    }
        // console.log(this.$refs['rangeDatePicker_'+this.componentId])

    },
    methods: {
        onSelectedDate: function(value){
            let date = {
				start: moment(value.start).subtract(1, "days").format('YYYY-MM-DD'),
				end: moment(value.end).subtract(1, "days").format('YYYY-MM-DD')
			}

			this.selectedDate = date
            
            this.$emit('input',date)

            this.$emit('onSelectedDate',date);
        }
    },
    watch: {
        value: function(newVal , oldVal){
            this.selectedDate = newVal
            this.$refs['rangeDatePicker_'+this.componentId].dateRange = {
                start: new moment(this.selectedDate.start).add(1,"days").toDate(),
                end: new moment(this.selectedDate.end).add(1,"days").toDate()
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/elements/DateRangePicker.vue